/**
 * カート画面 削除ボタン
 */
export default class RemoveButton extends HTMLElement {

    constructor() {
        super();
    }
  
    connectedCallback() {
        this.addEventListener('click', (event) => {
            event.preventDefault();
            const updateModal = document.querySelector('[data-target-id="cart-update-alert"] dialog');
            if(updateModal) {
              updateModal.showModal();
            }
            
            if(this.getAttribute('data-custom-order-child-items') != '[]') {
              const json = JSON.parse(this.getAttribute('data-custom-order-child-items'));
              WLCart.removeCustomOrderChildItems(this, json);
            } else if(this.closest('[data-set-key]').dataset.setKey != 'false' && this.dataset.buildPrice == 'false') {
                // セット品の場合
                const setKey = this.closest('[data-set-key]').dataset.setKey;
                WLCart.updateSetQuantity(0, this);
    
            } else if (this.closest('[data-build-price-target]').dataset.buildPriceTarget != 'false') {
                // 組立料金対象商品の場合
                WLCart.updateBuildPriceTargetQuantity(0, this);
    
            } else if (this.closest('[data-build-price]').dataset.buildPrice != 'false') {
                // 組立料金の場合
                WLCart.updateBuildPriceQuantity(0, this);
    
            } else {
                WLCart.updateQuantity(0, this);
            }
        });
    }
}